import { Component, ViewModel, View } from "binder";
import { ITemplateSelector } from "../templateSelector";
import { getAsBoolean } from "../utilities";
import  { ContentView } from "./content-view"

export class ContentViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new ContentView();
    }
    public getTypeId(): string {
        return "VM-B251A32F-D961-45DF-A14F-8118C140540C"
    }

    public set content(v: ViewModel) { this._content = v; } public get content(): ViewModel { return this._content;} private _content: ViewModel;
    public set itemtemplateselector(v: ITemplateSelector) { this._itemtemplateselector = v; } public get itemtemplateselector(): ITemplateSelector { return this._itemtemplateselector;} private _itemtemplateselector: ITemplateSelector;
    public set templateselectorfunction(v: string) { this._templateselectorfunction = v; } public get templateselectorfunction(): string { return this._templateselectorfunction;} private _templateselectorfunction: string;
    public set importanthasselectorfunction(v: boolean) { this._importanthasselectorfunction = getAsBoolean(v); } public get importanthasselectorfunction(): boolean { return this._importanthasselectorfunction;} private _importanthasselectorfunction: boolean;
    
}
